<template>
    <div class="text-center">
        <i class="fal fa-spinner fa-spin fa-2x"></i>
    </div>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "SetupResponseRedirect",
        computed: {
            ...mapState({
                setupResponse: state => state.payment.setupResponse,
            })
        },
        mounted () {
            document.location.href = this.setupResponse.data;
        }
    }

</script>
